/**
 * Top bar with tab navigation (Open / Closed / All RMAs) and Create RMA action button.
 * Tab state lives in RmaListFiltersStore; tab clicks update the store then reload page 1 via RmaPagedListStore.
 */
import "./rma-list-top-bar.scss";
import { useCallback } from "react";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import ResolveCapability from "../../../../../components/resolve-capability/resolve-capability";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import dashboardTranslationsStore from "../../../../../dashboard-translation/stores/dashboard-translations-store";
import { PROFILE_CAPABILITIES } from "../../../../../models/ProfileCapabilities";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import rmaPagedListStore from "../../../rma-list-page/stores/rma-paged-list-store";
import RmaListTabsBar from "../rma-list-tabs-bar/rma-list-tabs-bar";

interface IProps {
    isLoading: boolean;
}

const RmaListTopBar: React.FC<IProps> = observer(({ isLoading }) => {
    const navigate = useNavigate();
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";

    return (
        <div className="rma-list-top-bar">
            {!dashboardTranslationsStore.isLoading && (
                <RmaListTabsBar isLoading={isLoading} />
            )}
            <div className="rma-list-top-bar__actions">
                {!dashboardTranslationsStore.isLoading && (
                    <ResolveCapability capability={PROFILE_CAPABILITIES.INTERNAL_RMA_CREATION}>
                        {({ isEnabled }) =>
                            isEnabled && (
                                <Button
                                    variant={BUTTON_VARIANTS.PrimaryAccent}
                                    text={getTranslation("CREATE_RMA", scope)}
                                    onClick={() => {
                                        rmsMixpanelStore.trackEvent("d&_create_rma");
                                        navigate({ pathname: "/create-rma" });
                                    }}
                                />
                            )
                        }
                    </ResolveCapability>
                )}
            </div>
        </div>
    );
});

export default RmaListTopBar;
